import { Topbar } from "./layout/topbar";
import { Content } from "./layout/content";
import { Box, Typography } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { NavBar } from "./layout/navBar";
import { Home } from "./features/home";
import { TradingCounterparties } from "./features/tradingCounterparties";
import { Brokers } from "./features/brokers";
import { Countries } from "./features/countries";
import { ErrorPage } from "./components/errorPage";
import { ErrorBoundary } from "react-error-boundary";
import { MenuBar } from "./layout/menu";
import { TradingCounterpartiesMenu } from "./features/tradingCounterparties/menu";
import { BrokersMenu } from "./features/brokers/menu";
import { CountriesMenu } from "./features/countries/menu";
import { Mergers } from "./features/mergers";
import { MergersMenu } from "./features/mergers/menu";
import { Admin } from "./features/admin";
import { AdminMenu } from "./features/admin/menu";
import { CounterpartyLookup } from "./features/counterpartyLookup";
import { CounterpartyLookupMenu } from "./features/counterpartyLookup/menu";
import { WarehouseSync } from "./features/warehouseSync";
import { WarehouseSyncMenu } from "./features/warehouseSync/menu";
import { useIsAuthenticated, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useState } from "react";
import { TechnoMode } from "./components/technoMode";

const App = () => {
  useMsalAuthentication(InteractionType.Redirect, {
    prompt: "select_account"
  });

  const isAuthenticated = useIsAuthenticated();
  // Only used below md, where the nav rail is replaced by an overlay drawer opened from the topbar.
  const [navDrawerOpen, setNavDrawerOpen] = useState(false);

  if (!isAuthenticated) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        flexDirection="column"
        textAlign="center"
        gap={2}
      >
        <Typography variant="h4" color="primary">
          Authenticating...
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Please wait while we log you into the Market Access Portal.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <TechnoMode />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflowY: "hidden",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Topbar onOpenNav={() => setNavDrawerOpen(true)} />
        {/* Fills whatever the topbar leaves: its toolbar is 56px on phones and 64px on desktop. */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            minHeight: 0
          }}
        >
          {/*
            Sidebar routes - only if you want to use a left sidebar

            <Routes>
              <Route path="/" element={<Sidebar />} />
            </Routes> */}
          <ErrorBoundary FallbackComponent={ErrorPage}>
            <NavBar
              mobileOpen={navDrawerOpen}
              onMobileClose={() => setNavDrawerOpen(false)}
            />
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column"
              }}
            >
              <MenuBar>
                <Routes>
                  <Route
                    path="tradingcounterparties/*"
                    element={<TradingCounterpartiesMenu />}
                  />
                  <Route path="brokers/*" element={<BrokersMenu />} />
                  <Route path="mergers/*" element={<MergersMenu />} />
                  <Route path="countries/*" element={<CountriesMenu />} />
                  <Route path="admin/*" element={<AdminMenu />} />
                  <Route
                    path="counterpartylookup/*"
                    element={<CounterpartyLookupMenu />}
                  />
                  <Route
                    path="warehousesync/*"
                    element={<WarehouseSyncMenu />}
                  />
                </Routes>
              </MenuBar>
              <Content>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="home/*" element={<Home />} />
                  <Route
                    path="tradingcounterparties/*"
                    element={<TradingCounterparties />}
                  />
                  <Route path="brokers/*" element={<Brokers />} />
                  <Route path="mergers/*" element={<Mergers />} />
                  <Route path="countries/*" element={<Countries />} />
                  <Route
                    path="counterpartylookup/*"
                    element={<CounterpartyLookup />}
                  />
                  <Route path="warehousesync/*" element={<WarehouseSync />} />
                  <Route path="admin/*" element={<Admin />} />
                </Routes>
              </Content>
            </Box>
          </ErrorBoundary>
        </Box>
      </Box>
    </>
  );
};

export default App;
